import MainTabButtonListBox from '@/pages/function/components/MainTabButtonListBox';
import MainContentListBox from '@/pages/function/components/MainContentListBox';
import MainSubContentListBox from '@/pages/function/components/MainSubContentListBox';
import VodPopup from '@/pages/function/components/VodPopup';
import useScrollReset from '@/hooks/useScrollReset';

const MainFunctionPage = () => {
	useScrollReset();
	return (
		<>
			<section className="sub-content">
				<div className="cont1">
					<div className="sub-inner">
						<MainTabButtonListBox />
					</div>
					<MainContentListBox />
				</div>
				<div className="cont2">
					<div className="sub-inner">
						<MainSubContentListBox />
					</div>
				</div>
			</section>
			<VodPopup />
		</>
	);
};

export default MainFunctionPage;
